import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, from, of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from './../../../../shared/service';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { CacheService } from 'src/app/core/cache/cache.service';

@Injectable()
export class ApiResponseInterceptor implements HttpInterceptor {
  countError: number = 0;
  constructor(private authService: AuthService, private cacheService: CacheService) { this.countError = 0 }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 403) {
      this.countError += 1;

      // Reset count to 0
      setTimeout(() => {
        this.countError = 0;
      }, 2 * 60 * 1000);

      if (this.countError >= 12) {
        this.countError = 0;
        this.authService.logout();
        // this.messageService.add({
        //   key: 'emptyToster',
        //   severity: 'error',
        //   life: 10000,
        //   summary: 'Error',
        //   detail: 'Session Expired!'
        // });
      }
      return throwError(err);
    }

    if (err.status === 401) {
      this.authService.logout();
      // this.messageService.add({
      //   key: 'emptyToster',
      //   severity: 'error',
      //   life: 10000,
      //   summary: 'Error',
      //   detail: 'Session Expired!'
      // });
    }
    return throwError(err);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const fullUrl = request.url.startsWith('http')
      ? request.url
      : environment.baseurl + request.url;

    const shortUrl = new URL(fullUrl).pathname;

    const cachePolicyHeader = request.headers.get('x-cache-policy');
    const cachePolicy = cachePolicyHeader ? JSON.parse(cachePolicyHeader) : null;

    // First, check if the cache exists for GET request and return cached data if applicable
    if (cachePolicy) {
      return from(this.cacheService.get(shortUrl)).pipe(
        switchMap((cachedData: any) => {
          if (cachedData) {
            // Cache hit, return cached response immediately
            return of(new HttpResponse({ body: cachedData, status: 200 }));
          }

          // No cache hit, continue with the HTTP request
          return next.handle(request).pipe(
            tap((event: any) => {
              if (event instanceof HttpResponse && request.method === 'GET') {
                const cacheHeader = request.headers.get('x-cache-policy');
                const shortUrl = request.url.replace(environment.baseurl, '');
                console.log('response interceptor', event, cacheHeader, shortUrl);
                if (cacheHeader) {
                  try {
                    const cachePolicy = JSON.parse(cacheHeader);
                    this.cacheService.set(shortUrl, event.body, {
                      ttl: cachePolicy.ttl,
                      persistUntilLogout: cachePolicy.persistUntilLogout,
                    });
                  } catch (e) {
                    // Invalid cache policy, avoid caching
                    console.error('Invalid cache policy for', request.url);
                  }
                }
              }
            }),
            catchError(err => {
              return this.handleAuthError(err);  // Handle specific authentication errors if needed
            })
          );
        })
      );
    }

    return next.handle(request).pipe(
      catchError((err) => {
        return this.handleAuthError(err);  // Handle specific authentication errors if needed
      }));

    // Proceed with the HTTP request if no cache or not a GET request

  }

}
